import { KeyRound } from "lucide-react";
import { Link } from "~/components/Link";
import { Routes } from "~/routes";
import { McpUserEvents } from "~/modules/analytics/events/mcp";
import { mcpConfig } from "../../lib/mcp-config";

// // // //

/**
 * SecretNote
 * Lightweight "keep this key private" reminder shown alongside API-key setup.
 * Unlike OAuth client secrets, API keys are re-viewable and revocable from the
 * API Keys page, so this is a gentle note rather than a one-time-secret warning.
 */
export function SecretNote() {
    return (
        <div className="flex items-start gap-3 rounded-md border bg-muted px-3 py-2.5">
            <KeyRound
                className="mt-0.5 size-4 shrink-0 text-muted-foreground"
                aria-hidden="true"
            />
            <p className="text-xs leading-relaxed text-muted-foreground">
                Treat this key like a password — anyone with it can query{" "}
                {mcpConfig.serverName} as you. You can view or revoke it anytime
                from{" "}
                <Link
                    href={Routes.apiToolsApiKeys}
                    openInNewTab
                    analyticsLabel={McpUserEvents.ViewApiKeys}
                    className="whitespace-nowrap font-medium text-link underline-offset-4 hover:underline"
                >
                    API Keys
                </Link>
                .
            </p>
        </div>
    );
}
